import { useQuery } from '@apollo/client'

import {
  PIN_IS_AVAILABLE,
  PinIsAvailableQuery,
  PinIsAvailableQueryVariables,
} from '@/graphql'

export const usePinAvailability = (pin: string, userId?: string) => {
  const { data, loading, error } = useQuery<
    PinIsAvailableQuery,
    PinIsAvailableQueryVariables
  >(PIN_IS_AVAILABLE, {
    variables: { pinNumber: pin, userId },
  })

  const isAvailable = data?.pinIsAvailable
  return { isAvailable, loading, error }
}
